import { useState } from 'react';
import {
    getMediaErrorMessage,
    MEDIA_ERROR_TOAST_ID,
} from '@/utils/error-messages';
import { toast } from '@/components';

interface VideoThumbnailProps {
    src: string;
    className?: string;
    onLoad?: () => void;
    generatingPreview?: boolean;
}

export function VideoThumbnail({
    src,
    className,
    onLoad,
    generatingPreview = false,
}: VideoThumbnailProps) {
    const [error, setError] = useState(false);

    const handleError = async (e: React.SyntheticEvent<HTMLVideoElement>) => {
        setError(true);
        if (!generatingPreview) {
            const errorMessage = await getMediaErrorMessage(e);
            if (errorMessage) {
                toast.error(errorMessage, { id: MEDIA_ERROR_TOAST_ID });
            }
        }
    };

    if (error) {
        if (generatingPreview) {
            return (
                <div
                    className={`bg-grey-700 flex items-center justify-center ${className || ''}`}
                >
                    <span className="text-grey-300 text-sm">
                        Generating preview...
                    </span>
                </div>
            );
        }
        return (
            <div
                className={`bg-grey-700 flex items-center justify-center ${className || ''}`}
            >
                <span className="text-grey-400 text-xs">
                    Failed to load video
                </span>
            </div>
        );
    }

    return (
        <video
            src={src}
            crossOrigin="use-credentials"
            muted
            playsInline
            className={`w-full h-full object-cover ${className || ''}`}
            onLoadedData={(e) => {
                const video = e.currentTarget;
                video.currentTime = 0;
                video.pause();
                onLoad?.();
            }}
            onError={handleError}
        />
    );
}
